<template>
  <div
    class="pl-thirtyFive relative mb-base"
    data-test="feed-item"
  >
    <div
      v-if="showGrayLine"
      class="absolute bg-signableBrandColours-midGrey -bottom-base top-eighteen left-eleven w-px"
      data-test="gray-line"
    >
    </div>
    <div class="absolute left-none -top-4 w-twentyTwo h-twentyTwo rounded-full bg-whiteOverride border-signableBrandColours-midGrey border-solid border-1"></div>
    <div
      class="text-signableBrandColours-darkGrey text-14 sm:text-12 font-bold"
      data-test="feed-item-date"
    >
      {{ item.created_at | formatDate('timestamp_with_timezone', historyInUTC) }}
    </div>
    <div class="mt-sm w-full p-base flex gap-sm flex-col sm:flex-row sm:items-center justify-between bg-whiteOverride rounded-xl border-signableBrandColours-midGrey border-solid border-1">
      <div
        class="text-black text-16 sm:text-14 font-normal overflow-hidden overflow-ellipsis"
        data-test="feed-item-detail"
      >
        {{ item.detail }}
      </div>
      <div
        v-if="item.ip"
        class="text-signableBrandColours-darkGrey text-12 font-normal"
        data-test="feed-item-ip"
      >
        ({{ item.ip }})
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    item: Object,
    showGrayLine: {
      type: Boolean,
      required: true,
    },
    historyInUTC: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
